import gql from 'graphql-tag';

const registerClientWorkspaceLeadInLmsMutation = gql`
  mutation registerClientWorkspaceLeadInLmsMutation(
    $leadId: MongoID!
    $course: RegisterClientWorkspaceLeadCourseInput
  ) {
    registerClientWorkspaceLeadInLmsMutation(leadId: $leadId, course: $course) {
      leadId
      lmsStudentId
      status
    }
  }
`;
export default registerClientWorkspaceLeadInLmsMutation;
